// extracted by mini-css-extract-plugin
module.exports = {"link":"MenuItem_link__z7D9S","text":"MenuItem_text__cuoU5","active":"MenuItem_active__XpBww"};